import { useState, useEffect } from 'react';

const getStorageOrDefault = (storageTypeInstance, key, defaultValue = null) => {
    const stored = storageTypeInstance.getItem(key);
    if (stored === null) {
        return defaultValue;
    }
    return JSON.parse(stored);
}

const getStorageByType = (type) => {
    if (type === "localStorage") {
        return localStorage;
    } else {
        return sessionStorage;
    }
}

function useStorage(key, defaultValue, type = "sessionStorage") {
    const storageTypeInstance = getStorageByType(type);
    const [value, setValue] = useState(
        getStorageOrDefault(storageTypeInstance, key, defaultValue)
    );


    useEffect(() => {
        storageTypeInstance.setItem(key, JSON.stringify(value));
    }, [key, value]);

    return [value, setValue];
}

export const useSessionStorage = (key, defaultValue) => useStorage(key, defaultValue, "sessionStorage");
export const useLocalStorage = (key, defaultValue) => useStorage(key, defaultValue, "localStorage");